<div class="content">
    <hhsg-message-bar [messages]="errorMessages" [isError]="hasErrorMessages" [visibilityTimeout]="hasErrorMessages ? 0 : 5" [yOffset]="messageBarOffset"></hhsg-message-bar>
    <hhsg-page-header [headerText]="headerLabel" [subHeaderText]="subHeaderLabel" [showBreadCrumb]="showBreadCrumb" [displayDivider]="false" class="admin-header tab-header">
        <div header-buttons class="nav-buttons">
            <dx-button *ngIf="useHeaderButton" type="default" stylingMode="outlined" [text]="headerButtonText" (onClick)="onHeaderButtonClicked();"></dx-button>
            <hhsg-shared-ellipses-control [ellipsesMenuItems]="ellipsesMenuItems" (ellipsesButtonClicked)="onEllipsisButtonClicked($event)">
            </hhsg-shared-ellipses-control>
        </div>
        <div class="drop-down-menu" *ngIf="menuItemLength > 0">
            <dx-select-box
                id="dropDownValue"
                class="drop-down-select"
                #dropDownValue
                [(dataSource)]="dropDownMenuItemsFinal"
                [label]="dropDownName"
                displayExpr="labelName"
                valueExpr="value"
                [(value)]="selectedDropdownValue"
                [disabled]="isDropDownDisabled"
                (onValueChanged)="onChangeDropdownOption($event)"
                width="300px"
                [stylingMode]="dxStylingMode"
				ngDefaultControl
                [searchEnabled]="true">
                <div *ngIf="showInactive">
                    <div *dxTemplate="let data of 'field'">
                        <div [ngClass]="{'inactive-label': !data.isActive}">
                            <dx-text-box class="" [value]="data && data.labelName" [readOnly]="true"></dx-text-box>
                        </div>
                    </div>
                
                    <div *dxTemplate="let data of 'item'">
                        <div [ngClass]="{'inactive-label': !data.isActive}">
                            <span class="">
                                {{ data.labelName }}
                            </span>
                            <span *ngIf="!data.isActive">(Inactive)</span>
                        </div>
                    </div>
                </div>
            </dx-select-box>
            <mat-icon *ngIf="dropDownToolTipText?.length > 0" id="tooltip" 
                class="material-icons-outlined tooltip-icon" (click)="toggleTooltip()">info</mat-icon>
            <dx-tooltip target="#tooltip" position="top" [(visible)]="showTooltip" [hideOnOutsideClick]="true">
                <div *dxTemplate="let data of 'content'">{{dropDownToolTipText}}</div>
            </dx-tooltip>
        </div>
    </hhsg-page-header>
    <section class="tabs-container" [ngClass]="!useHeaderLabel ? 'mt-n3' : ''">
            <!-- Figure out what to do about this mobile design. Viewable on start a round in Rounding
            Its all messed up between certain screen widths.  -->
            <div *ngIf="allowMobile" class="mobile-tab" >
                <button class="dropbtn mt-n1" (click)="mobileTabCollapse = !mobileTabCollapse" >{{selectedTab.labelName}}<span class="material-symbols-outlined">more_vert</span></button>
                <div id="myDropdown" class="dropdown-content" [ngClass]="mobileTabCollapse ? null : 'show'" >
                    <a *ngFor="let tab of visibleTabs; let i = index;" (click)="onTabClick($event, tab)">{{tab.labelName}}</a>
                </div>
            </div>
            <div class="tab-header">
                <ng-container *ngFor="let tab of visibleTabs; let i = index;">
                    <input type="radio" name="tabs" id="tab-{{ i }}" (click)="onTabClick($event, tab)" [class.m-hide]="allowMobile"
                        [checked]="tab.id == selectedTab.id" [disabled]="tab.isDisabled">
                    <label for="tab-{{i}}" class="tab-title" [class.m-hide]="allowMobile"
                     [class.selected]="tab.id == selectedTab.id">{{ tab.labelName }}</label>
                </ng-container>
            </div>
            <ng-container *ngFor="let tab of visibleTabs; let i = index;">
                <div class="tab-content" id="tab-content-{{ i }}" [class.selected]="tab.id == selectedTab.id">
                    <hhsg-dynamic-tab [isSaveTab]="isSaveTab" [currentTab]="tab" (cancelButtonClicked)="onCancelClicked()"
                    (errorMessages)="setErrorMessages($event)" (saveButtonClicked)="onSaveClicked()">
                    </hhsg-dynamic-tab>
                </div>
            </ng-container>
    </section>
</div>

<hhsg-shared-modal [isActive]="displayDeactivation" (acceptEvent)="onDeactivateLeaveTab()"
    (rejectEvent)="displayDeactivation = false" [disableFooter]="false" [disableHeader]="true">
    <div role="body">
        You have unsaved changes. Do you want to leave this tab?
    </div>
    <div role="footer">
        <div class="button-group">
            <dx-button stylingMode="contained" type="default" class="action-button" (click)="displayDeactivation = false">Continue Editing</dx-button>
            <dx-button stylingMode="outlined" type="default" class="action-button" (click)="onDeactivateLeaveTab()">Leave Tab</dx-button>
        </div>
    </div>
</hhsg-shared-modal>
